import { useState, useEffect } from 'react';
import axios from '../../api/Axios';

const ManageCampuses = () => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [institution, setInstitution] = useState('');
  const [institutions, setInstitutions] = useState([]);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('api/institution_view/')
      .then(res => {
        setInstitutions(res.data);
      })
      .catch(() => {
        setInstitutions([]);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult(null);
    setError('');
    try {
      const payload = {
        name,
        address,
        institution: institution ? parseInt(institution) : null,
        academic_cycle: null,
      };
      const response = await axios.post('api/campus_create/', payload);
      setResult(response.data);
    } catch (err) {
      setError(
        err.response?.data
          ? JSON.stringify(err.response.data)
          : "Submission failed"
      );
    }
  };

  return (
    <div className="booking-form mt-4">
      <h4 className="mb-3">Add Campus</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-row mb-3">
          <div className="form-group col-md-6 mb-3">
            <input
              className="form-control homeforms"
              type="text"
              placeholder="Enter campus name"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group col-md-6 mb-3">
            <input
              className="form-control homeforms"
              type="text"
              placeholder="Enter address"
              value={address}
              onChange={e => setAddress(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="form-row mb-3">
          <div className="form-group col-md-6 mb-3">
            <select
              className="form-control homeforms"
              value={institution}
              onChange={e => setInstitution(e.target.value)}
              required
            >
              <option value="">Select Institution</option>
              {institutions.map(inst => (
                <option key={inst.id} value={inst.id}>
                  {inst.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-btn">
          <button className="btn btn-primary btn-block" type="submit">
            Submit
          </button>
        </div>
      </form>
      {result && (
        <div className="alert alert-success mt-3">
          Success: {JSON.stringify(result)}
        </div>
      )}
      {error && (
        <div className="alert alert-danger mt-3">
          Error: {error}
        </div>
      )}
    </div>
  );
};

export default ManageCampuses;